import Cookies from 'js-cookie';
import useInterval from 'beautiful-react-hooks/useInterval';
import { useTranslation } from 'react-i18next';
import config from '../../../config';

export default function useLanguageUpdate() {
  const { i18n } = useTranslation();

  useInterval(() => {
    const languageCookie = Cookies.get(config.Translation.CookieName);
    if (languageCookie && i18n.language !== languageCookie) {
      i18n.changeLanguage(languageCookie);
    }
  }, 1000);
}
